import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Reservation prompt rendered in a portal to document.body so fixed
 * positioning works even inside containers that establish a new
 * containing block (e.g. transform/filter/container-type).
 *
 * Props:
 *   item      — { name } — gift being reserved
 *   value     — name input value
 *   onChange  — (name: string) => void
 *   onConfirm — () => void
 *   onClose   — () => void
 *   sending   — boolean
 *   error     — string | null
 *   classes   — CSS class map (bg / modal / title / subtitle / input / error / btns / btnCancel / btnConfirm)
 */
export default function WishlistReserveModal({
  item, value, onChange, onConfirm, onClose, sending, error, classes = {},
}) {
  if (!item) return null;
  const cls = {
    bg:         classes.bg         || 'wish-modal-bg',
    modal:      classes.modal      || 'wish-modal',
    title:      classes.title      || 'wish-modal-title',
    subtitle:   classes.subtitle   || 'wish-modal-sub',
    input:      classes.input      || 'wish-modal-input',
    error:      classes.error      || 'wish-modal-err',
    btns:       classes.btns       || 'wish-modal-btns',
    btnCancel:  classes.btnCancel  || 'wish-modal-cancel',
    btnConfirm: classes.btnConfirm || 'wish-modal-confirm',
  };
  return createPortal(
    <div className={cls.bg} onClick={() => !sending && onClose()}>
      {/* Модалка рендерится в портал к document.body — вне области CSS-
          переменных шаблона, поэтому background:var(--…) у шаблонов не
          резолвится и фон получается прозрачным. Задаём сплошной белый. */}
      <div className={cls.modal} style={{ background: '#fff' }} onClick={e => e.stopPropagation()}>
        <h3 className={cls.title}>Резервируем: {item.name}</h3>
        <p className={cls.subtitle}>Укажите ваше имя — чтобы молодожёны знали, от кого подарок.</p>
        <input
          className={cls.input}
          placeholder="Ваше имя"
          value={value}
          onChange={e => onChange(e.target.value)}
          autoFocus
        />
        {error && <div className={cls.error}>{error}</div>}
        <div className={cls.btns}>
          <button type="button" className={cls.btnCancel} disabled={sending} onClick={onClose}>Отмена</button>
          <button type="button" className={cls.btnConfirm} disabled={sending} onClick={onConfirm}>
            {sending ? '...' : 'Зарезервировать'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
